import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { PageLoader } from "@/components/PageLoader";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Journal from "@/pages/Journal";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import CategorySlideshow from "@/pages/CategorySlideshow";
import Admin from "@/pages/Admin";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import NotFound from "@/pages/NotFound";
import { LanguageProvider } from "@/lib/i18n";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// Admin bekommt ein eigenes schlichtes Layout ohne die öffentliche Kopf-/Fußzeile
const AppChrome = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return (
    <>
      <Navbar />
      <PageLoader />
    </>
  );
};

const AppFooter = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return <Footer />;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-obsidian font-sans text-bone">
      <BrowserRouter>
        <LanguageProvider>
          <ScrollToTop />
          <AppChrome />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/en" element={<Home />} />
              <Route path="/portfolio" element={<Navigate to="/projekte" replace />} />
              <Route path="/en/portfolio" element={<Navigate to="/en/projects" replace />} />
              <Route path="/fieldnotes" element={<Journal />} />
              <Route path="/en/fieldnotes" element={<Journal />} />
              <Route path="/projekte" element={<Projects />} />
              <Route path="/en/projects" element={<Projects />} />
              <Route path="/projekte/esprit-roca" element={<Navigate to="/projekte/esperit-roca" replace />} />
              <Route path="/en/projects/esprit-roca" element={<Navigate to="/en/projects/esperit-roca" replace />} />
              <Route path="/projekte/rubrik/:art" element={<CategorySlideshow />} />
              <Route path="/en/projects/rubrik/:art" element={<CategorySlideshow />} />
              <Route path="/projekte/:slug" element={<ProjectDetail />} />
              <Route path="/en/projects/:slug" element={<ProjectDetail />} />
              <Route path="/ueber-mich" element={<About />} />
              <Route path="/en/about" element={<About />} />
              <Route path="/kontakt" element={<Contact />} />
              <Route path="/en/contact" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/en/imprint" element={<Impressum />} />
              <Route path="/en/privacy" element={<Datenschutz />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <AppFooter />
          <div className="grain-overlay" aria-hidden="true" />
          <Toaster position="bottom-right" theme="light" />
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
